import ArticleCard from "@components/Cards/ArticleCard";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import React from "react";
import { twMerge } from "tailwind-merge";

export const ArticleGridCards = ({
  article,
  articleIndex,
  rootClassName,
  cardWrapper,
  imageWrapperStyle,
  refMedium,
  hasShowAuthor = false,
}: {
  article: ProcessedArticleData[];
  articleIndex: number;
  rootClassName?: string;
  cardWrapper?: string;
  imageWrapperStyle?: string;
  refMedium?: string;
  hasShowAuthor?: boolean;
}) => {
  return (
    <div
      key={articleIndex}
      className={twMerge(
        "xmd:grid xmd:grid-cols-4 gap-3 xmd:gap-4",
        rootClassName,
      )}
    >
      {article.map((context, index) => (
        <React.Fragment key={index}>
          <ArticleCard
            key={context.id}
            displayWidth={311}
            displayHeight={233}
            {...context}
            elements={{ hasParagraph: false, hasDate: true, hasShowAuthor }}
            overrideStyle={{
              cardWrapper: `pt-0 pb-5 flex-row lg:flex-col w-full xmd:w-[306px] lg:border-b-0 md:gap-2.5 lg:gap-3.2 xmd:gap-2 ${cardWrapper}`,
              titleClass:
                "font-semibold font-primary text-base xmd:text-xl text-grey-500 hover:text-grey-500 hover:no-underline leading-400",
              imageWrapperStyle: `max-w-[140px] xmd:max-w-[311px] xmd:w-full ${imageWrapperStyle}`,
              imageStyle: "min-w-34 w-full",
              dateClass: "text-sm font-opensans",
              bottomInfoWrapperStyle: "md:mt-auto",
              contentWrapper: "gap-2",
            }}
            refMedium={refMedium}
          />
        </React.Fragment>
      ))}
    </div>
  );
};
